import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/composition/Enter/Enter';
import '@/components/content/Icon/Icon';
import { useAppState } from '@/lib/AppState';
export default function TipContent({ tip, ctaWidth = 'full-width', showImage = true, }) {
    const { publicPath } = useAppState();
    if (!tip) {
        return null;
    }
    const tipImgSrc = tip.image ?? `${publicPath}images/material-tip.svg`;
    return (_jsxs("diamond-enter", { type: "fade", children: [showImage && (_jsx("img", { className: "diamond-spacing-bottom-sm", src: tipImgSrc, alt: "" })), tip.subtitle && (_jsx("p", { className: "diamond-text-weight-bold", children: tip.subtitle })), _jsx("h2", { children: tip.title }), tip.content && _jsx("p", { children: tip.content }), tip.cta && tip.ctaLink && (_jsx("diamond-button", { width: ctaWidth, className: "diamond-spacing-top-md", children: _jsxs("a", { href: tip.ctaLink, target: "_blank", rel: "noopener noreferrer", children: [tip.cta, _jsx("locator-icon", { icon: "external" })] }) }))] }));
}
